import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import ArrowDown from 'utils/images/arrow-down.svg';
import PriceWithSymbol from '../../../../../../utils/currency/PriceWithSymbol';
import { PATH_KEY_TO_POSITION } from '../../constants';
import { StateContext } from '../../contexts/use-menu-editor-context';
import {
  displayChoiceLimit,
  displayChoiceLimitHeader,
  displayPriceSubUnit,
} from '../../utils';
import Panel from '../shared/Panel';
import Required from '../shared/Required';
import VariantList from '../VariantList';
import ProductEditor from './product-editor';

const LEVEL = PATH_KEY_TO_POSITION['productIdx'];

const SelectedGroupsPanel = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 849px;
  margin-bottom: 10px;
  box-sizing: border-box;
  border-radius: 5px;
`;
const PanelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
  ${props =>
    props.expanded &&
    css`
      height: 100%;
    `}
`;

const OptionGroupHeader = styled.h3`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 400;
  margin-top: 0.4px;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.2px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  color: #000000;
`;

const PriceAndLimitContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: left;
  align-items: center;
  flex-direction: row;
  margin-right: 220px;
  gap: 30px;
`;
const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;
`;
const Limit = styled.h3`
  margin: 0px;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
  letter-spacing: -0.2px;
  color: #000000;
  margin-right: -35px;
  @media only screen and (min-width: 375px) and (max-width: 540px) {
    position: absolute;
    right: 58px;
  }
`;

const Wrapper = styled.div``;

const SelectedOptionGroupContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 12px;
  align-items: baseline;
  padding-bottom: 24px;
`;
const SelectedChoiceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 3px;
  padding-bottom: 3px;
`;
const ChoiceWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 58px;
`;
const Price = styled.h3`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  right: 450px;
  @media only screen and (min-width: 768px) and (max-width: 900px) {
    position: absolute;
    right: 280px;
  }
  @media only screen and (min-width: 375px) and (max-width: 540px) {
    position: absolute;
    right: 135px;
  }
`;
const LimitWrapper = styled.div`
  position: absolute;
  right: 343px;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  @media only screen and (min-width: 768px) and (max-width: 900px) {
    position: absolute;
    right: 185px;
  }
  @media only screen and (min-width: 375px) and (max-width: 540px) {
    position: absolute;
    right: 58px;
  }
`;
const ExpanderArrow = styled.div`
  width: 12px;
  height: 7px;
  line-height: 12px;
  transform: rotate(270deg);
  cursor: pointer;
  ${props =>
    props.expanded &&
    css`
      transform: rotate(0deg);
      cursor: pointer;
      margin-top: -8px;
      margin-left: 0px;
    `}
  ${props =>
    props.hide &&
    css`
      visibility: hidden;
    `}
`;

const OgTitle = styled.span`
  font-weight: normal;
  ${props =>
    props.expanded &&
    css`
      font-weight: 600;
    `}
`;
const ChoiceName = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  margin: 0;
  @media only screen and (min-width: 375px) and (max-width: 540px) {
    margin-bottom: 15px;
  }
`;

const AllWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 110px;
  @media only screen and (min-width: 375px) and (max-width: 540px) {
    margin-left: 25px;
  }
`;
function ProductItem(props) {
  const {
    product,
    menuIdx,
    categoryIdx,
    productIdx,
    parent,
    setIsEditMode,
    isExpanded,
    setIsExpanded,
    isAnyChildItemExpanded,
  } = props;

  const [showProductEditor, setShowProductEditor] = useState(false);
  const [showSelectedOptions, setShowSelectedOptions] = useState({});

  const { state } = useContext(StateContext);
  const { optionGroups } = state;
  const toggleEditor = () => {
    setShowProductEditor(!showProductEditor);
    setIsEditMode(!showProductEditor);
  };
  const appliedOptionGroups = (optionGroups || []).filter(og =>
    og.productIds.includes(product.id)
  );

  return (
    <Panel
      key={`product-item-panel-${product.id}`}
      item={product}
      level={LEVEL}
      price={displayPriceSubUnit(product.price)}
      onEdit={toggleEditor}
      hideExpandedSummaryBorder={true}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      isAnyChildItemExpanded={isAnyChildItemExpanded}
      hasOptionGroups={Boolean(appliedOptionGroups.length)}
    >
      {Boolean(showProductEditor) ? (
        <ProductEditor
          product={product}
          menuIdx={menuIdx}
          categoryIdx={categoryIdx}
          productIdx={productIdx}
          onCancel={toggleEditor}
          setShowEditor={setShowProductEditor}
          parent={parent}
        />
      ) : (
        <React.Fragment>
          <AllWrapper>
            {appliedOptionGroups.map(option => {
              return (
                <SelectedGroupsPanel expanded={showSelectedOptions[option.id]}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <PanelWrapper
                      expanded={showSelectedOptions[option.id]}
                      onClick={() => {
                        const groupStatus = {
                          ...showSelectedOptions,
                          [option.id]: !showSelectedOptions[option.id],
                        };
                        setShowSelectedOptions(groupStatus);
                      }}
                    >
                      <ExpanderArrow
                        expanded={showSelectedOptions[option.id]}
                        id={`${option.id}`}
                      >
                        <img alt="expand arrow" src={ArrowDown} />
                      </ExpanderArrow>
                      <HeaderWrapper expanded={!showSelectedOptions[option.id]}>
                        <OptionGroupHeader
                          expanded={!showSelectedOptions[option.id]}
                        >
                          <OgTitle expanded={showSelectedOptions[option.id]}>
                            {option.name}
                          </OgTitle>
                          {option.required && <Required>Required</Required>}
                          {showSelectedOptions[option.id] && (
                            <LimitWrapper>
                              {option.variantType === 'multiple'
                                ? displayChoiceLimitHeader(option.choice_limit)
                                : null}
                            </LimitWrapper>
                          )}
                        </OptionGroupHeader>
                      </HeaderWrapper>
                    </PanelWrapper>
                  </div>
                  <Wrapper>
                    {showSelectedOptions[option.id] &&
                      (option.children || []).map(og => {
                        return (
                          <SelectedOptionGroupContainer>
                            <SelectedChoiceWrapper>
                              <ChoiceWrapper>
                                <ChoiceName>{og.name}</ChoiceName>
                              </ChoiceWrapper>
                            </SelectedChoiceWrapper>
                            <PriceAndLimitContainer>
                              <Price>
                                <PriceWithSymbol
                                  price={displayPriceSubUnit(og.price)}
                                />
                              </Price>
                              <Limit>
                                {displayChoiceLimit(og.choice_limit)}
                              </Limit>
                            </PriceAndLimitContainer>
                          </SelectedOptionGroupContainer>
                        );
                      })}
                  </Wrapper>
                </SelectedGroupsPanel>
              );
            })}
          </AllWrapper>
          <VariantList
            menuIdx={menuIdx}
            categoryIdx={categoryIdx}
            productIdx={productIdx}
            parent={product}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
          />
        </React.Fragment>
      )}
    </Panel>
  );
}

const mapStateToProps = state => {
  const venue = state.venue;

  return {
    venue: venue,
  };
};

export default connect(mapStateToProps)(ProductItem);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/ProductList/product-item.jsx